import { render, staticRenderFns } from "./MAM_transtionReward.vue?vue&type=template&id=e83bcb74&scoped=true&"
import script from "./MAM_transtionReward.vue?vue&type=script&lang=js&"
export * from "./MAM_transtionReward.vue?vue&type=script&lang=js&"
import style0 from "./MAM_transtionReward.vue?vue&type=style&index=0&id=e83bcb74&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e83bcb74",
  null
  
)

export default component.exports